import { ButtonLink } from '@/components/ui/Button';
import { Seo } from '@/features/site/Seo';

export default function NotFoundPage() {
  return (
    <>
      <Seo title="Page not found" path="/404" noindex />
      <section className="container-page grid min-h-[55vh] place-items-center py-16 text-center">
        <div>
          <p className="font-display text-[64px] leading-none font-bold text-muted">404</p>
          <h1 className="mt-4 text-[28px] font-bold tracking-tight">We couldn&apos;t find that page</h1>
          <p className="mx-auto mt-2 max-w-md text-[14.5px] text-muted">The link may be outdated or the product may no longer be listed. You can browse the catalog or send us your requirements directly.</p>
          <div className="mt-7 flex flex-wrap justify-center gap-3">
            <ButtonLink to="/">Go to home page</ButtonLink>
            <ButtonLink to="/apparel" variant="outline">
              Browse products
            </ButtonLink>
            <ButtonLink to="/contact#inquiry" variant="outline">
              Request a quote
            </ButtonLink>
          </div>
        </div>
      </section>
    </>
  );
}
